import { UnstakeAction } from '../types'
import { stakingRewardsAbi } from '@/config/abis/stakingRewardsAbi'
import { trackTransactionConfirmation } from '@/domain/analytics/cookie3'
import { getBalancesQueryKeyPrefix } from '@/domain/wallet/getBalancesQueryKeyPrefix'
import { ensureConfigTypes } from '@/features/actions/logic/transactions/useWrite'
import { ActionConfig, ActionContext } from '@/features/actions/logic/types'
import { spkFarmDataQueryKey } from '@/features/spk/farm/data/useSpkFarmData'

export function createUnstakeActionConfig(action: UnstakeAction, context: ActionContext): ActionConfig {
  const { account, chainId } = context

  return {
    getWriteConfig: () => {
      const { stakingToken, farm } = action
      const amount = stakingToken.toBigInt(action.amount)

      if (action.exit) {
        return ensureConfigTypes({
          address: farm,
          abi: stakingRewardsAbi,
          functionName: 'exit',
          args: [],
        })
      }

      return ensureConfigTypes({
        address: farm,
        abi: stakingRewardsAbi,
        functionName: 'withdraw',
        args: [amount],
      })
    },

    invalidates: () => [getBalancesQueryKeyPrefix({ chainId, account }), spkFarmDataQueryKey({ account, chainId })],

    onSuccessfulAction: () => {
      if (action.stakingToken.symbol === 'USDS' && action.rewardToken.symbol === 'SPK') {
        trackTransactionConfirmation({
          name: 'farm_withdraw',
          value: action.stakingToken.toUSD(action.amount).toNumber(),
          isInSandbox: Boolean(context.isInSandbox),
        })
      }
    },
  }
}
